export enum SettingsExceptions {
  UNAUTHORIZED_ACCESS = "UNAUTHORIZED_ACCESS",
  INVALID_SETTINGS = "INVALID_SETTINGS",
}
